import { useState, useEffect, useCallback } from "react";
import EcoLogoImg from "./assets/EcoLogo.png";
import img1 from "./assets/img1.jpg";
import img2 from "./assets/img1.jpg";
import img3 from "./assets/img3.jpg";
import img4 from "./assets/img4.jpg";
import img5 from "./assets/img5.jpg";


const C = {
  greenDeep:"#1a4a2e", greenMid:"#2d7a4f", greenBright:"#3da86a",
  greenLight:"#7ec99a", greenPale:"#d4f0e0", cream:"#f9f5ed",
  warmWhite:"#fdfaf4", charcoal:"#1c1c1c", midGray:"#555",
  lightGray:"#e8e8e0", gold:"#c8a94a", darkBg:"#0e1a12",
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);
  return isMobile;
};

const EcoLogo = ({ size = 60 }) => (
  <img src={EcoLogoImg} alt="EcoPro" width={size} height={size} />
);
const SLIDES = [
  {
    img: img1,
    tag: "♻️ Eco-Friendly", 
    headline: "Sustainable Living",
    sub: "Make smarter choices for a greener future"
  },
  {
    img: img2,
    tag: "💚 Pre-Loved",
    headline: "Give Items a Second Life",
    sub: "Buy and sell quality second-hand goods"
  },
  {
    img: img3,
    tag: "🌍 Community",
    headline: "Connect Locally",
    sub: "Trade with people near you"
  },
  {
    img: img4,
    tag: "✨ Easy & Fast",
    headline: "Simple Swapping",
    sub: "List and find items in seconds"
  },
  {
    img: img5,
    tag: "✨ Declutter & Donate With Purpose",
    headline: "Charities list what they need. Donors give with precision",
    sub: "Every donation reaches someone who truly needs it"
  }
    
  
];
//const SLIDES = [
 // { img:"https://sustainableroggie.com/wp-content/uploads/2021/07/Secondhand-stores-to-thrift-clothes-online.jpg", tag:"♻️ Swap & Declutter", headline:<>Give Every Item<br/><em style={{fontStyle:"italic",color:C.greenBright}}>A Second Life</em></>, sub:"List your second-hand, fairly used, and pre-loved items and find them a new home fast." },
  //{ img:"https://giftstoearth.com/cdn/shop/articles/Sustainable_Thrift_Store_for_Eco-Friendly_Choices.jpg", tag:"💚 Pre-Loved Items", headline:<>Shop Smarter.<br/><em style={{fontStyle:"italic",color:C.greenBright}}>Live Greener.</em></>, sub:"Discover affordable, quality items from people near you. Every purchase reduces waste." },
  //{ img:"https://c8.alamy.com/comp/2ABKF7F/clothing-donation-2ABKF7F.jpg", tag:"🏥 Donate with Purpose", headline:<>Donations That<br/><em style={{fontStyle:"italic",color:C.greenBright}}>Actually Land.</em></>, sub:"NGOs list exactly what they need. Donors give with precision. Every donation reaches someone who truly needs it." },
  //{ img:"https://www.ecothrift.com/wp-content/uploads/2023/04/eco-thrift-store.jpg", tag:"🌍 Africa & UK", headline:<>One Platform.<br/><em style={{fontStyle:"italic",color:C.greenBright}}>Two Continents.</em></>, sub:"Launching across Nigeria and the United Kingdom — bridging two markets with one sustainable mission." },
//];

// ── NAV ──
const Nav = ({ scrolled }) => {
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);
  const scroll = (e,h) => { e.preventDefault(); document.querySelector(h)?.scrollIntoView({behavior:"smooth"}); setMenuOpen(false); };
  const links = [["How It Works","#how"],["Markets","#markets"],["Model","#model"],["🤖 AI Auction","#auction",true]];
  return (
    <nav style={{position:"fixed",top:0,left:0,right:0,zIndex:200,background:scrolled?"rgba(253,250,244,0.97)":"rgba(253,250,244,0.85)",backdropFilter:"blur(16px)",borderBottom:`1px solid rgba(61,168,106,${scrolled?.18:.08})`,boxShadow:scrolled?"0 4px 30px rgba(0,0,0,0.07)":"none",transition:"all .35s"}}>
      <div style={{padding:"12px 5%",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <a href="#top" onClick={e=>scroll(e,"#top")} style={{display:"flex",alignItems:"center",gap:10,textDecoration:"none"}}>
          <EcoLogo size={60}/>
          <span style={{fontFamily:"Georgia,serif",fontSize:isMobile?18:21,fontWeight:900,color:C.greenDeep}}>EcoPro</span>
        </a>
        {isMobile ? (
          <button onClick={()=>setMenuOpen(!menuOpen)} style={{background:"none",border:"none",cursor:"pointer",fontSize:24,color:C.greenDeep,padding:4}}>
            {menuOpen ? "✕" : "☰"}
          </button>
        ) : (
          <ul style={{display:"flex",gap:24,listStyle:"none",margin:0,padding:0,alignItems:"center"}}>
            {links.map(([lb,h,gold])=>(
              <li key={lb}><a href={h} onClick={e=>scroll(e,h)} style={{textDecoration:"none",fontSize:13,fontWeight:500,color:gold?C.gold:C.midGray}}>{lb}{gold&&<sup style={{fontSize:9,background:C.gold,color:"#fff",padding:"2px 5px",borderRadius:100,marginLeft:4,fontWeight:700}}>SOON</sup>}</a></li>
            ))}
            <li><a href="#waitlist" onClick={e=>scroll(e,"#waitlist")} style={{background:C.greenMid,color:"#fff",padding:"9px 20px",borderRadius:100,fontSize:13,fontWeight:700,textDecoration:"none"}}>Join Waitlist</a></li>
          </ul>
        )}
      </div>
      {/* Mobile Menu */}
      {isMobile && menuOpen && (
        <div style={{background:"rgba(253,250,244,0.98)",borderTop:`1px solid ${C.greenPale}`,padding:"1rem 5%",display:"flex",flexDirection:"column",gap:16}}>
          {links.map(([lb,h,gold])=>(
            <a key={lb} href={h} onClick={e=>scroll(e,h)} style={{textDecoration:"none",fontSize:15,fontWeight:600,color:gold?C.gold:C.greenDeep,padding:"6px 0",borderBottom:`1px solid ${C.lightGray}`}}>{lb}</a>
          ))}
          <a href="#waitlist" onClick={e=>scroll(e,"#waitlist")} style={{background:C.greenMid,color:"#fff",padding:"12px 20px",borderRadius:100,fontSize:15,fontWeight:700,textDecoration:"none",textAlign:"center",marginTop:4}}>Join Waitlist</a>
        </div>
      )}
    </nav>
  );
};

// ── HERO SLIDER ──
const Hero = () => {
  const isMobile = useIsMobile();
  const [cur,setCur] = useState(0);
  const [animating,setAnimating] = useState(false);
  const scroll = (e,h) => { e.preventDefault(); document.querySelector(h)?.scrollIntoView({behavior:"smooth"}); };
  const go = useCallback((idx)=>{ if(animating) return; setAnimating(true); setTimeout(()=>{ setCur(idx); setAnimating(false); },400); },[animating]);
  const next = useCallback(()=>go((cur+1)%SLIDES.length),[cur,go]);
  const prev = useCallback(()=>go((cur-1+SLIDES.length)%SLIDES.length),[cur,go]);
  useEffect(()=>{ const t=setInterval(next,5500); return()=>clearInterval(t); },[next]);
  const s = SLIDES[cur];
  return (
    <section id="top" style={{minHeight:"100vh",position:"relative",display:"flex",alignItems:"center",overflow:"hidden",paddingTop:70}}>
      <div style={{position:"absolute",inset:0,zIndex:0,transition:"opacity .4s",opacity:animating?.0:1}}>
        <img src={s.img} alt="" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center"}} onError={e=>e.target.style.display="none"}/>
        <div style={{position:"absolute",inset:0,background:"linear-gradient(100deg,rgba(10,30,18,0.85) 0%,rgba(10,30,18,0.60) 55%,rgba(10,30,18,0.25) 100%)"}}/>
        <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(10,30,18,0.75) 0%,transparent 50%)"}}/>
      </div>
      <div style={{position:"relative",zIndex:2,padding:isMobile?"0 6% 80px":"0 5%",maxWidth:760,transition:"opacity .4s,transform .4s",opacity:animating?0:1,transform:animating?"translateY(16px)":"translateY(0)"}}>
        <div style={{display:"inline-flex",alignItems:"center",gap:8,background:"rgba(61,168,106,0.22)",border:"1px solid rgba(61,168,106,0.45)",color:"#a8e6be",fontSize:isMobile?11:12,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",padding:"6px 16px",borderRadius:100,marginBottom:20}}>
          <span style={{width:6,height:6,borderRadius:"50%",background:C.greenBright,display:"inline-block"}}/>{s.tag}
        </div>
        <h1 style={{fontFamily:"Georgia,serif",fontSize:isMobile?"clamp(2.2rem,8vw,3rem)":"clamp(3rem,6vw,5rem)",fontWeight:900,lineHeight:1.06,color:"#fff",marginBottom:18,textShadow:"0 2px 20px rgba(0,0,0,.3)"}}>
          {s.headline}
        </h1>
        <p style={{fontSize:isMobile?14:17,lineHeight:1.75,color:"rgba(255,255,255,.80)",maxWidth:540,marginBottom:28,fontWeight:300}}>{s.sub}</p>
        <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:28}}>
          {[["👗","Second-Hand"],["✨","Fairly Used"],["💚","Pre-Loved"],["♻️","Swap & Donate"],["🌍","Africa & UK"]].map(([ic,tx])=>(
            <span key={tx} style={{display:"flex",alignItems:"center",gap:5,fontSize:isMobile?11:12,fontWeight:600,color:"#fff",background:"rgba(255,255,255,0.12)",border:"1px solid rgba(255,255,255,0.2)",padding:isMobile?"5px 10px":"6px 14px",borderRadius:8}}>{ic} {tx}</span>
          ))}
        </div>
        <div style={{display:"flex",gap:12,flexWrap:"wrap",alignItems:"center"}}>
          <a href="#waitlist" onClick={e=>scroll(e,"#waitlist")} style={{background:C.greenMid,color:"#fff",padding:isMobile?"12px 22px":"14px 30px",borderRadius:100,fontSize:isMobile?14:16,fontWeight:700,textDecoration:"none",boxShadow:`0 6px 24px rgba(45,122,79,.40)`}}>Join the Waitlist</a>
          <a href="#how" onClick={e=>scroll(e,"#how")} style={{color:"#fff",border:"1.5px solid rgba(255,255,255,.45)",background:"rgba(255,255,255,0.08)",padding:isMobile?"12px 18px":"14px 26px",borderRadius:100,fontSize:isMobile?14:16,fontWeight:600,textDecoration:"none"}}>How It Works</a>
        </div>
      </div>
      <button onClick={prev} style={{position:"absolute",left:isMobile?8:20,top:"50%",transform:"translateY(-50%)",zIndex:10,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.25)",color:"#fff",width:isMobile?36:46,height:isMobile?36:46,borderRadius:"50%",fontSize:isMobile?16:20,cursor:"pointer",backdropFilter:"blur(6px)",display:"flex",alignItems:"center",justifyContent:"center"}}>‹</button>
      <button onClick={next} style={{position:"absolute",right:isMobile?8:20,top:"50%",transform:"translateY(-50%)",zIndex:10,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.25)",color:"#fff",width:isMobile?36:46,height:isMobile?36:46,borderRadius:"50%",fontSize:isMobile?16:20,cursor:"pointer",backdropFilter:"blur(6px)",display:"flex",alignItems:"center",justifyContent:"center"}}>›</button>
      <div style={{position:"absolute",bottom:28,left:"50%",transform:"translateX(-50%)",zIndex:10,display:"flex",gap:8,alignItems:"center"}}>
        {SLIDES.map((_,i)=>(
          <button key={i} onClick={()=>go(i)} style={{width:i===cur?24:7,height:7,borderRadius:100,background:i===cur?"#fff":"rgba(255,255,255,0.40)",border:"none",cursor:"pointer",transition:"all .3s",padding:0}}/>
        ))}
      </div>
    </section>
  );
};

// ── PROBLEM ──
const Problem = () => {
  const isMobile = useIsMobile();
  return (
    <section style={{padding:isMobile?"4rem 6%":"6rem 5%",background:C.greenDeep,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",top:-200,right:-200,width:600,height:600,background:"radial-gradient(circle,rgba(61,168,106,.18) 0%,transparent 70%)",pointerEvents:"none"}}/>
      <div style={{fontFamily:"monospace",fontSize:11,letterSpacing:"0.18em",textTransform:"uppercase",color:C.greenLight,marginBottom:12}}>The Problem</div>
      <h2 style={{fontFamily:"Georgia,serif",fontSize:isMobile?"1.8rem":"clamp(2rem,4vw,3rem)",fontWeight:900,color:"#fff",lineHeight:1.15,marginBottom:14}}>Three broken systems.<br/>One unified solution.</h2>
      <p style={{fontSize:15,lineHeight:1.75,color:"rgba(255,255,255,.65)",maxWidth:580,marginBottom:36,fontWeight:300}}>Millions of items sit idle while people struggle to find affordable goods, NGOs lack what they need, and the planet pays the price.</p>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(3,1fr)",gap:16}}>
        {[["01","Items Stuck in Limbo","Second-hand clothes, fairly used electronics, pre-loved furniture — items with real value sit idle with no easy, responsible way to find a new home."],["02","NGOs Lacking Donations","Charities struggle to receive relevant, timely donations and lack tools to coordinate efficient logistics and item matching."],["03","Broken Logistics","Delivery is expensive in developed markets and nearly inaccessible in emerging ones — leaving sustainable exchange impossible where it's needed most."]].map(([num,title,desc])=>(
          <div key={num} style={{background:"rgba(255,255,255,.06)",border:"1px solid rgba(255,255,255,.1)",borderRadius:20,padding:isMobile?"1.4rem":"1.8rem"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:48,fontWeight:900,color:C.greenBright,opacity:.3,lineHeight:1,marginBottom:8}}>{num}</div>
            <h3 style={{fontSize:16,fontWeight:700,marginBottom:8,color:"#fff"}}>{title}</h3>
            <p style={{fontSize:14,color:"rgba(255,255,255,.6)",lineHeight:1.65,fontWeight:300}}>{desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

// ── HOW IT WORKS ──
const HowItWorks = () => {
  const isMobile = useIsMobile();
  const [active,setActive] = useState("users");
  const tabs=[{id:"users",label:"👤 Users"},{id:"charities",label:"🏥 Charities"},{id:"riders",label:"🛵 Riders"}];
  const content={
    users:{icon:"🔄",title:"Every item deserves a second life",desc:"Whether it's a barely-worn jacket, a fairly used phone, or pre-loved furniture — EcoPro gives every item a new purpose.",steps:[["List Your Item","Take a photo, add a description, and list any second-hand, fairly used, or pre-loved item."],["Choose: Swap, Sell or Donate","Exchange with another user, donate to a registered NGO, or list affordably."],["Arrange Delivery","Connect with an independent rider near you for affordable, fast collection and delivery."],["Track & Make Impact","Follow your item's journey and see the real-world impact your swap or donation creates."]]},
    charities:{icon:"🏥",title:"Structured giving, real impact",desc:"Charities no longer need to hope for the right donations to arrive. EcoPro gives organisations the tools to communicate their needs precisely.",steps:[["Register Your Organisation","Sign up as a verified NGO — quick onboarding, no complex integrations."],["List What You Need","Post specific items your organisation needs so donors give exactly what helps."],["Receive Matched Donations","Our system matches nearby donors with your listed needs automatically."],["Coordinate Pickup","Independent riders handle collection and delivery everywhere."]]},
    riders:{icon:"🛵",title:"Independent. Flexible. Impactful.",desc:"Our rider network empowers individuals in any city — from Lagos to London — to earn by doing good.",steps:[["Sign Up as a Rider","Register independently with just your vehicle and ID."],["Accept Nearby Requests","Browse delivery jobs in your area and accept what works for you."],["Collect & Deliver","Pick up items and deliver with built-in route guidance."],["Earn & Build Reputation","Get paid per delivery and grow your profile."]]},
  };
  const c=content[active];
  return (
    <section id="how" style={{padding:isMobile?"4rem 6%":"6rem 5%",background:C.cream}}>
      <div style={{maxWidth:560,marginBottom:32}}>
        <div style={{fontFamily:"monospace",fontSize:11,letterSpacing:"0.18em",textTransform:"uppercase",color:C.greenBright,marginBottom:12}}>How It Works</div>
        <h2 style={{fontFamily:"Georgia,serif",fontSize:isMobile?"1.8rem":"clamp(2rem,4vw,3rem)",fontWeight:900,color:C.greenDeep,lineHeight:1.15,marginBottom:12}}>One platform.<br/>Three journeys.</h2>
        <p style={{fontSize:15,lineHeight:1.75,color:C.midGray,fontWeight:300}}>EcoPro serves users, NGOs, and riders — each with a tailored experience.</p>
      </div>
      <div style={{display:"flex",gap:6,background:C.lightGray,padding:5,borderRadius:100,width:"fit-content",marginBottom:32,flexWrap:"wrap"}}>
        {tabs.map(t=>(
          <button key={t.id} onClick={()=>setActive(t.id)} style={{padding:isMobile?"8px 16px":"9px 22px",borderRadius:100,border:"none",fontFamily:"inherit",fontSize:13,fontWeight:700,cursor:"pointer",transition:"all .2s",background:active===t.id?C.greenMid:"transparent",color:active===t.id?"#fff":C.midGray}}>
            {t.label}
          </button>
        ))}
      </div>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:isMobile?"2rem":"4rem",alignItems:"center"}}>
        <div style={{display:"flex",flexDirection:"column",gap:18}}>
          {c.steps.map(([h,p],i)=>(
            <div key={i} style={{display:"flex",gap:14,alignItems:"flex-start"}}>
              <div style={{minWidth:40,height:40,background:C.greenMid,color:"#fff",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"monospace",fontSize:12,fontWeight:700,flexShrink:0}}>0{i+1}</div>
              <div>
                <h4 style={{fontWeight:700,marginBottom:4,color:C.greenDeep,fontSize:14}}>{h}</h4>
                <p style={{fontSize:13,color:C.midGray,lineHeight:1.65,fontWeight:300}}>{p}</p>
              </div>
            </div>
          ))}
        </div>
        <div style={{background:`linear-gradient(135deg,${C.greenDeep},${C.greenMid})`,borderRadius:24,padding:"2rem",color:"#fff",minHeight:isMobile?200:280,display:"flex",flexDirection:"column",justifyContent:"center",position:"relative",overflow:"hidden"}}>
          <div style={{position:"absolute",top:-60,right:-60,width:200,height:200,borderRadius:"50%",border:"40px solid rgba(255,255,255,.07)"}}/>
          <div style={{fontSize:48,marginBottom:14}}>{c.icon}</div>
          <h3 style={{fontFamily:"Georgia,serif",fontSize:isMobile?18:22,fontWeight:900,marginBottom:10}}>{c.title}</h3>
          <p style={{fontSize:13,opacity:.75,lineHeight:1.65,fontWeight:300}}>{c.desc}</p>
        </div>
      </div>
    </section>
  );
};

// ── PILLARS ──
const Pillars = () => {
  const isMobile = useIsMobile();
  return (
    <section style={{padding:isMobile?"4rem 6%":"6rem 5%",background:C.warmWhite}}>
      <div style={{fontFamily:"monospace",fontSize:11,letterSpacing:"0.18em",textTransform:"uppercase",color:C.greenBright,marginBottom:12}}>Our Differentiators</div>
      <h2 style={{fontFamily:"Georgia,serif",fontSize:isMobile?"1.8rem":"clamp(2rem,4vw,3rem)",fontWeight:900,color:C.greenDeep,lineHeight:1.15,marginBottom:36}}>One platform.<br/>Three superpowers.</h2>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(3,1fr)",gap:16}}>
        {[{bg:"linear-gradient(135deg,#f0faf4,#e0f5e9)",border:"rgba(61,168,106,.25)",icon:"🔄",title:"Swap, Sell & Declutter",desc:"List second-hand, fairly used, or pre-loved items and exchange them with others — no money required, just mutual value.",tag:"Circular Economy"},{bg:"linear-gradient(135deg,#fff0e6,#fae0d0)",border:"rgba(200,120,58,.2)",icon:"🤝",title:"Structured Donations",desc:"NGOs list exactly what they need. Donors see real requests and give with precision. Every donation lands where it matters.",tag:"Social Impact"},{bg:"linear-gradient(135deg,#eef6ff,#ddeeff)",border:"rgba(58,120,200,.2)",icon:"🛵",title:"Independent Delivery",desc:"Our rider model works without existing logistics infrastructure — unlocking sustainable exchange across Africa and the UK.",tag:"Innovation"}].map(p=>(
          <div key={p.title} style={{background:p.bg,border:`1.5px solid ${p.border}`,borderRadius:22,padding:"1.8rem"}}>
            <span style={{fontSize:34,marginBottom:14,display:"block"}}>{p.icon}</span>
            <h3 style={{fontFamily:"Georgia,serif",fontSize:18,fontWeight:700,marginBottom:8,color:C.greenDeep}}>{p.title}</h3>
            <p style={{fontSize:13,color:C.midGray,lineHeight:1.7,fontWeight:300}}>{p.desc}</p>
            <span style={{display:"inline-block",marginTop:12,fontSize:11,fontWeight:700,letterSpacing:"0.08em",textTransform:"uppercase",padding:"5px 12px",borderRadius:100,background:"rgba(0,0,0,.07)",color:C.greenDeep}}>{p.tag}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

// ── MARKETS ──
const Markets = () => {
  const isMobile = useIsMobile();
  return (
    <section id="markets" style={{padding:isMobile?"4rem 6%":"6rem 5%",background:C.cream}}>
      <div style={{fontFamily:"monospace",fontSize:11,letterSpacing:"0.18em",textTransform:"uppercase",color:C.greenBright,marginBottom:12}}>Market Strategy</div>
      <h2 style={{fontFamily:"Georgia,serif",fontSize:isMobile?"1.8rem":"clamp(2rem,4vw,3rem)",fontWeight:900,color:C.greenDeep,lineHeight:1.15,marginBottom:14}}>Two markets.<br/>Two opportunities.</h2>
      <p style={{fontSize:15,lineHeight:1.75,color:C.midGray,maxWidth:580,marginBottom:36,fontWeight:300}}>Launching across Africa and the UK allows us to prove our model in two very different market conditions — simultaneously.</p>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:20}}>
        <div style={{background:C.greenDeep,borderRadius:22,padding:isMobile?"1.8rem":"2.5rem",color:"#fff"}}>
          <span style={{fontSize:40,display:"block",marginBottom:12}}>🌍</span>
          <h3 style={{fontFamily:"Georgia,serif",fontSize:isMobile?22:26,fontWeight:900,marginBottom:8}}>Africa</h3>
          <p style={{fontSize:14,color:"rgba(255,255,255,.65)",lineHeight:1.7,fontWeight:300}}>Home to over 1.4 billion people and some of the world's fastest-growing economies. Starting in Nigeria with expansion across the continent.</p>
          <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:16}}>
            {["Starting in Nigeria","Logistics Gap","NGO Ecosystem","1.4B+ Population"].map(t=>(
              <span key={t} style={{fontSize:11,fontWeight:600,padding:"5px 12px",borderRadius:100,background:"rgba(255,255,255,.12)",color:"#fff"}}>{t}</span>
            ))}
          </div>
        </div>
        <div style={{background:"#fff",border:`2px solid ${C.greenPale}`,borderRadius:22,padding:isMobile?"1.8rem":"2.5rem"}}>
          <span style={{fontSize:40,display:"block",marginBottom:12}}>🇬🇧</span>
          <h3 style={{fontFamily:"Georgia,serif",fontSize:isMobile?22:26,fontWeight:900,marginBottom:8,color:C.greenDeep}}>United Kingdom</h3>
          <p style={{fontSize:14,color:C.midGray,lineHeight:1.7,fontWeight:300}}>A sustainability-conscious culture, a strong reuse economy, and rising cost-of-living pressures make the UK a perfect market.</p>
          <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:16}}>
            {["Sustainability Culture","Reuse Economy","Cost of Living","Established Charities"].map(t=>(
              <span key={t} style={{fontSize:11,fontWeight:600,padding:"5px 12px",borderRadius:100,background:C.greenPale,color:C.greenDeep}}>{t}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// ── BUSINESS MODEL ──
const BusinessModel = () => {
  const isMobile = useIsMobile();
  return (
    <section id="model" style={{padding:isMobile?"4rem 6%":"6rem 5%",background:C.warmWhite}}>
      <div style={{fontFamily:"monospace",fontSize:11,letterSpacing:"0.18em",textTransform:"uppercase",color:C.greenBright,marginBottom:12}}>Business Model</div>
      <h2 style={{fontFamily:"Georgia,serif",fontSize:isMobile?"1.8rem":"clamp(2rem,4vw,3rem)",fontWeight:900,color:C.greenDeep,lineHeight:1.15,marginBottom:14}}>Built to grow.<br/>Built to last.</h2>
      <p style={{fontSize:15,lineHeight:1.75,color:C.midGray,maxWidth:580,marginBottom:36,fontWeight:300}}>Multiple revenue streams ensure EcoPro remains sustainable as it scales.</p>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:14}}>
        {[["🚚","Delivery Fees","A small fee per delivery, shared between the platform and the rider."],["⭐","Premium Swaps","Commission on high-value exchanges through premium listing tiers."],["🏥","NGO Partnerships","Sponsored partnerships and featured listings for registered charities."],["🔑","Subscriptions","Future plans for frequent swappers, power users, and businesses."]].map(([ic,h,p])=>(
          <div key={h} style={{background:C.cream,border:`1px solid ${C.lightGray}`,borderRadius:18,padding:"1.6rem 1.2rem",textAlign:"center"}}>
            <span style={{fontSize:30,marginBottom:10,display:"block"}}>{ic}</span>
            <h4 style={{fontWeight:700,fontSize:14,color:C.greenDeep,marginBottom:6}}>{h}</h4>
            <p style={{fontSize:12,color:C.midGray,lineHeight:1.55,fontWeight:300}}>{p}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

// ── AI AUCTION ──
const AIAuction = () => {
  const isMobile = useIsMobile();
  const [secs,setSecs] = useState(272);
  useEffect(()=>{ const t=setInterval(()=>setSecs(s=>s<=0?300:s-1),1000); return()=>clearInterval(t); },[]);
  const mm=String(Math.floor(secs/60)).padStart(2,"0"), ss=String(secs%60).padStart(2,"0");
  const scroll=(e,h)=>{ e.preventDefault(); document.querySelector(h)?.scrollIntoView({behavior:"smooth"}); };
  return (
    <section id="auction" style={{padding:isMobile?"4rem 6%":"7rem 5%",background:C.darkBg,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:"linear-gradient(rgba(61,168,106,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(61,168,106,.06) 1px,transparent 1px)",backgroundSize:"40px 40px",pointerEvents:"none"}}/>
      <div style={{position:"absolute",width:500,height:500,background:"rgba(61,168,106,.12)",borderRadius:"50%",top:-150,right:-100,filter:"blur(80px)",pointerEvents:"none"}}/>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:isMobile?"2.5rem":"5rem",alignItems:"center",position:"relative",zIndex:2}}>
        <div>
          <div style={{display:"inline-flex",alignItems:"center",gap:8,background:"rgba(200,169,74,.12)",border:"1px solid rgba(200,169,74,.35)",color:C.gold,fontSize:11,fontWeight:700,letterSpacing:"0.12em",textTransform:"uppercase",padding:"7px 18px",borderRadius:100,marginBottom:18}}>
            <span style={{width:6,height:6,borderRadius:"50%",background:C.gold,display:"inline-block"}}/>Coming Soon
          </div>
          <div style={{fontFamily:"monospace",fontSize:11,letterSpacing:"0.18em",textTransform:"uppercase",color:C.greenLight,marginBottom:10}}>AI-Powered Live Auction</div>
          <h2 style={{fontFamily:"Georgia,serif",fontSize:isMobile?"1.8rem":"clamp(2rem,4vw,3rem)",fontWeight:900,color:"#fff",lineHeight:1.15,marginBottom:14}}>Bid Smart.<br/><em style={{color:C.gold}}>Win Fair.</em></h2>
          <p style={{fontSize:14,lineHeight:1.75,color:"rgba(255,255,255,.55)",marginBottom:24,fontWeight:300}}>A live auction engine powered by AI that values items instantly, detects fair pricing, and creates a transparent bidding experience.</p>
          <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:24}}>
            {[["🤖","AI Item Valuation","Analyses photos, condition, and market trends for accurate pricing."],["⚡","Real-Time Live Bidding","Competitive auctions with countdown timers and outbid notifications."],["🛡️","Anti-Shill Detection","AI monitors bidding patterns to detect fraud in real time."],["🌍","Africa & UK Accessible","Works across different currencies and connectivity levels."]].map(([ic,h,p])=>(
              <div key={h} style={{display:"flex",gap:12,alignItems:"flex-start",background:"rgba(255,255,255,.04)",border:"1px solid rgba(255,255,255,.07)",borderRadius:12,padding:"12px 14px"}}>
                <span style={{fontSize:20,flexShrink:0}}>{ic}</span>
                <div>
                  <h4 style={{fontSize:13,fontWeight:700,color:"#fff",marginBottom:3}}>{h}</h4>
                  <p style={{fontSize:12,color:"rgba(255,255,255,.5)",lineHeight:1.5,fontWeight:300}}>{p}</p>
                </div>
              </div>
            ))}
          </div>
          <a href="#waitlist" onClick={e=>scroll(e,"#waitlist")} style={{display:"inline-flex",alignItems:"center",gap:8,background:`linear-gradient(135deg,${C.gold},#e8c96a)`,color:"#1a1a0a",padding:"12px 24px",borderRadius:100,fontSize:14,fontWeight:700,textDecoration:"none"}}>
            🔔 Notify Me When It Launches
          </a>
        </div>
        <div style={{background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.1)",borderRadius:24,overflow:"hidden"}}>
          <div style={{background:"linear-gradient(135deg,rgba(45,122,79,.4),rgba(26,74,46,.6))",borderBottom:"1px solid rgba(255,255,255,.08)",padding:"14px 18px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span style={{fontSize:13,fontWeight:600,color:"#fff"}}>🏷️ Live Auction Preview</span>
            <span style={{display:"flex",alignItems:"center",gap:5,fontSize:10,fontWeight:700,letterSpacing:"0.08em",textTransform:"uppercase",color:"#ff5f5f"}}>
              <span style={{width:6,height:6,borderRadius:"50%",background:"#ff5f5f",display:"inline-block"}}/>LIVE
            </span>
          </div>
          <div style={{height:140,background:"linear-gradient(135deg,#1a3a25,#2d5a3f)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:64,position:"relative"}}>
            👟
            <span style={{position:"absolute",top:10,right:10,fontSize:9,fontWeight:700,background:"rgba(200,169,74,.85)",color:"#1a1a0a",padding:"3px 8px",borderRadius:100}}>AI ANALYSED</span>
          </div>
          <div style={{padding:"1.2rem"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,fontWeight:700,color:"#fff",marginBottom:3}}>Nike Air Max 90 — Size 10</div>
            <div style={{fontSize:11,color:C.greenLight,fontWeight:600,marginBottom:12}}>✅ Condition: Very Good · Authenticated by AI</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
              {[["Current Bid","£38.00",true],["AI Suggested","£42.00",false],["Bidders","7",false],["Time Left",`${mm}:${ss}`,false]].map(([lb,val,gold])=>(
                <div key={lb} style={{background:"rgba(255,255,255,.05)",borderRadius:8,padding:"8px",textAlign:"center"}}>
                  <div style={{fontSize:9,color:"rgba(255,255,255,.4)",fontWeight:500,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:3}}>{lb}</div>
                  <div style={{fontFamily:"monospace",fontSize:15,fontWeight:700,color:gold?C.gold:"#fff"}}>{val}</div>
                </div>
              ))}
            </div>
            <div style={{background:"rgba(200,169,74,.08)",border:`1px solid rgba(200,169,74,.2)`,borderRadius:8,padding:"8px 10px",display:"flex",gap:8,alignItems:"flex-start",marginBottom:10}}>
              <span style={{fontSize:14}}>🤖</span>
              <p style={{fontSize:11,color:"rgba(255,255,255,.6)",lineHeight:1.5,margin:0}}><strong style={{color:C.gold}}>AI Insight:</strong> Similar listings sold for £35–£48. Current bid is below fair value.</p>
            </div>
            <button style={{width:"100%",background:`linear-gradient(135deg,${C.greenMid},${C.greenBright})`,color:"#fff",border:"none",padding:10,borderRadius:8,fontSize:12,fontWeight:700,fontFamily:"inherit",cursor:"not-allowed",opacity:.7}}>🔒 Bidding Opens at Launch</button>
          </div>
        </div>
      </div>
    </section>
  );
};

// ── WAITLIST ──
const Waitlist = () => {
  const isMobile = useIsMobile();
  const [submitted,setSubmitted] = useState(false);
  const [loading,setLoading] = useState(false);
  const [form,setForm] = useState({first:"",last:"",email:"",phone:"",country:"",city:"",role:"",source:"",message:"",consent:false});
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  const inp={background:"rgba(255,255,255,.08)",border:"1px solid rgba(255,255,255,.15)",borderRadius:10,padding:"10px 14px",color:"#fff",fontFamily:"inherit",fontSize:14,outline:"none",width:"100%",boxSizing:"border-box"};

  const submit = async () => {
    if(!form.first||!form.email||!form.country||!form.role||!form.consent) {
      alert("Please fill in all required fields and agree to the terms.");
      return;
    }
    setLoading(true);
    // ── REPLACE THIS URL WITH YOUR SHEETDB API URL ──
    const SHEETDB_URL = "https://sheetdb.io/api/v1/gx9qbbcwq97wi";
    try {
      await fetch(SHEETDB_URL, {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ data: [{ ...form, consent: form.consent?"Yes":"No", date: new Date().toLocaleDateString() }] })
      });
    } catch(e) { console.log("Submission error", e); }
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <section id="waitlist" style={{padding:isMobile?"4rem 6%":"6rem 5%",background:C.greenDeep,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",bottom:-200,left:-200,width:600,height:600,background:"radial-gradient(circle,rgba(61,168,106,.15) 0%,transparent 70%)",pointerEvents:"none"}}/>
      <div style={{maxWidth:700,margin:"0 auto",textAlign:"center",position:"relative",zIndex:2}}>
        <div style={{fontFamily:"monospace",fontSize:11,letterSpacing:"0.18em",textTransform:"uppercase",color:C.greenLight,marginBottom:12}}>Join the Movement</div>
        <h2 style={{fontFamily:"Georgia,serif",fontSize:isMobile?"1.8rem":"clamp(2rem,4vw,3rem)",fontWeight:900,color:"#fff",lineHeight:1.15,marginBottom:14}}>Be First.<br/>Shape the Future.</h2>
        <p style={{fontSize:15,lineHeight:1.75,color:"rgba(255,255,255,.65)",margin:"0 auto 32px",fontWeight:300}}>Join the EcoPro waitlist and get early access when we launch across Africa and the UK.</p>
        <div style={{background:"rgba(255,255,255,.07)",border:"1px solid rgba(255,255,255,.12)",borderRadius:24,padding:isMobile?"1.5rem":"2rem",backdropFilter:"blur(10px)"}}>
          {!submitted?(
            <div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:12,marginBottom:12,textAlign:"left"}}>
                {[["First Name","first","text","Your first name",true],["Last Name","last","text","Your last name",true],["Email Address","email","email","your@email.com",true],["Phone Number","phone","tel","+44 or +234...",false]].map(([lb,k,t,ph,req])=>(
                  <div key={k}>
                    <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,.7)",display:"block",marginBottom:6}}>{lb}{req?" *":""}</label>
                    <input type={t} placeholder={ph} value={form[k]} onChange={e=>set(k,e.target.value)} style={inp}/>
                  </div>
                ))}
                <div>
                  <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,.7)",display:"block",marginBottom:6}}>Your Location *</label>
                  <select value={form.country} onChange={e=>set("country",e.target.value)} style={inp}>
                    <option value="" disabled>Select your country</option>
                    <optgroup label="🌍 Africa">
                      {["🇳🇬 Nigeria","🇬🇭 Ghana","🇰🇪 Kenya","🇿🇦 South Africa","🌍 Other African Country"].map(o=><option key={o}>{o}</option>)}
                    </optgroup>
                    <optgroup label="🇬🇧 United Kingdom">
                      {["🏴󠁧󠁢󠁥󠁮󠁧󠁿 England","🏴󠁧󠁢󠁳󠁣󠁴󠁿 Scotland","🏴󠁧󠁢󠁷󠁬󠁳󠁿 Wales","🇬🇧 Northern Ireland"].map(o=><option key={o}>{o}</option>)}
                    </optgroup>
                    <option>🌐 Other</option>
                  </select>
                </div>
                <div>
                  <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,.7)",display:"block",marginBottom:6}}>City / State</label>
                  <input type="text" placeholder="e.g. Lagos, London, Accra" value={form.city} onChange={e=>set("city",e.target.value)} style={inp}/>
                </div>
                <div>
                  <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,.7)",display:"block",marginBottom:6}}>I'm interested as... *</label>
                  <select value={form.role} onChange={e=>set("role",e.target.value)} style={inp}>
                    <option value="" disabled>Select your role</option>
                    {["A User (Swap & Donate)","An NGO / Charity","A Delivery Rider","An Investor / Partner","Multiple Roles"].map(o=><option key={o}>{o}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,.7)",display:"block",marginBottom:6}}>How did you hear about us?</label>
                  <select value={form.source} onChange={e=>set("source",e.target.value)} style={inp}>
                    <option value="" disabled>Select source</option>
                    {["Social Media","Friend / Referral","Google Search","News / Press","Other"].map(o=><option key={o}>{o}</option>)}
                  </select>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,.7)",display:"block",marginBottom:6}}>What excites you most about EcoPro?</label>
                  <textarea placeholder="Tell us what you love about this idea..." value={form.message} onChange={e=>set("message",e.target.value)} rows={3} style={{...inp,resize:"vertical"}}/>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"flex-start",gap:12,margin:"14px 0 20px",textAlign:"left"}}>
                <input type="checkbox" id="consent" checked={form.consent} onChange={e=>set("consent",e.target.checked)} style={{marginTop:2,accentColor:C.greenBright,width:16,height:16,flexShrink:0}}/>
                <label htmlFor="consent" style={{fontSize:12,color:"rgba(255,255,255,.6)",lineHeight:1.5}}>I agree to receive updates from EcoPro and Thecla Technologies &amp; Services Limited. We respect your privacy and will never spam you.</label>
              </div>
              <button onClick={submit} disabled={loading} style={{width:"100%",background:loading?"rgba(61,168,106,.5)":C.greenBright,color:"#fff",border:"none",padding:16,borderRadius:100,fontSize:16,fontWeight:700,cursor:loading?"not-allowed":"pointer",fontFamily:"inherit",boxShadow:`0 6px 24px rgba(61,168,106,.40)`,transition:"all .2s"}}>
                {loading?"⏳ Submitting...":"🌱 Reserve My Spot on the Waitlist"}
              </button>
            </div>
          ):(
            <div style={{background:"rgba(61,168,106,.15)",border:`1px solid ${C.greenBright}`,borderRadius:14,padding:32,textAlign:"center"}}>
              <span style={{fontSize:52,display:"block",marginBottom:12}}>🎉</span>
              <h3 style={{fontFamily:"Georgia,serif",fontSize:22,color:"#fff",marginBottom:10}}>You're on the list!</h3>
              <p style={{fontSize:14,color:"rgba(255,255,255,.7)"}}>Thank you for joining the EcoPro waitlist. We'll be in touch as soon as we launch in your region. 🌱</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

// ── FOOTER ──
const Footer = () => {
  const isMobile = useIsMobile();
  const scroll=(e,h)=>{ e.preventDefault(); document.querySelector(h)?.scrollIntoView({behavior:"smooth"}); };
  return (
    <>
      <footer style={{background:"#111",color:"rgba(255,255,255,.5)",padding:isMobile?"3rem 6%":"3rem 5%",display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr 1fr",gap:28}}>
        <div>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
            <EcoLogo size={60}/><span style={{fontFamily:"Georgia,serif",fontSize:19,fontWeight:900,color:C.greenLight}}>EcoPro</span>
          </div>
          <p style={{fontSize:13,lineHeight:1.65}}>A decluttering platform powered by swapping, donating, and accessible delivery — built for Africa, the UK, and the world.</p>
          <p style={{marginTop:10,fontSize:11,color:"rgba(255,255,255,.3)",fontFamily:"monospace"}}>Trading name of Thecla Technologies &amp; Services Limited</p>
        </div>
        <div>
          <h5 style={{color:"rgba(255,255,255,.8)",fontSize:12,fontWeight:700,marginBottom:14,letterSpacing:"0.06em",textTransform:"uppercase"}}>Platform</h5>
          <ul style={{listStyle:"none",display:"flex",flexDirection:"column",gap:10,padding:0,margin:0}}>
            {[["How It Works","#how"],["Our Markets","#markets"],["Business Model","#model"],["🤖 AI Auction","#auction"],["Join Waitlist","#waitlist"]].map(([lb,h])=>(
              <li key={lb}><a href={h} onClick={e=>scroll(e,h)} style={{color:"rgba(255,255,255,.45)",textDecoration:"none",fontSize:13}}>{lb}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h5 style={{color:"rgba(255,255,255,.8)",fontSize:12,fontWeight:700,marginBottom:14,letterSpacing:"0.06em",textTransform:"uppercase"}}>Company</h5>
          <ul style={{listStyle:"none",display:"flex",flexDirection:"column",gap:10,padding:0,margin:0}}>
            {["About EcoPro","For Charities","Become a Rider","Investors","Contact Us"].map(lb=>(
              <li key={lb}><span style={{color:"rgba(255,255,255,.45)",fontSize:13,cursor:"pointer"}}>{lb}</span></li>
            ))}
          </ul>
        </div>
      </footer>
      <div style={{background:"#0a0a0a",padding:"14px 5%",display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:12,color:"rgba(255,255,255,.25)",flexWrap:"wrap",gap:8}}>
        <span>© 2025 Thecla Technologies &amp; Services Limited · Trading as EcoPro · All rights reserved.</span>
        <span style={{display:"flex",gap:16}}>
          <span style={{color:"rgba(255,255,255,.35)",cursor:"pointer"}}>Privacy Policy</span>
          <span style={{color:"rgba(255,255,255,.35)",cursor:"pointer"}}>Terms of Service</span>
        </span>
      </div>
    </>
  );
};

// ── APP ──
export default function App() {
  const [scrolled,setScrolled] = useState(false);
  useEffect(()=>{ const h=()=>setScrolled(window.scrollY>20); window.addEventListener("scroll",h); return()=>window.removeEventListener("scroll",h); },[]);
  return (
    <div style={{fontFamily:"'Segoe UI',system-ui,sans-serif",background:C.warmWhite,color:C.charcoal,overflowX:"hidden"}}>
      <Nav scrolled={scrolled}/>
      <Hero/>
      <Problem/>
      <HowItWorks/>
      <Pillars/>
      <Markets/>
      <BusinessModel/>
      <AIAuction/>
      <Waitlist/>
      <Footer/>
    </div>
  );
}
